/* Veelgestelde vragen (sections/faq.liquid): a smooth height animation for the answers in browsers that cannot
   animate details on their own (no ::details-content with interpolate-size: Safari, Firefox and older Chrome).
   Where the browser can, section-faq.css does it and this file does nothing.
   It takes over one-open-at-a-time from the name attribute and theme.js (data-accordion), so a closing answer can
   animate too: a click on a question closes the open one smoothly and opens the new one smoothly. Keyboard (Enter,
   Space on the summary) works the same, since that is a click. Under reduced motion and with the site-wide motion
   switch answers open at once. Without JavaScript the native details work as they are. */

const root = document.documentElement;
const reducedQuery = matchMedia('(prefers-reduced-motion: reduce)');
const still = () =>
  reducedQuery.matches || root.classList.contains('is-reduced') || root.classList.contains('is-motion-paused');
const native = CSS.supports?.('selector(::details-content)') && CSS.supports?.('interpolate-size', 'allow-keywords');
const EASE = 'cubic-bezier(.22, 1, .36, 1)';
const MS = 460;

function animate(details, opening) {
  const panel = details.querySelector('.qa__a');
  details.faqClosing = !opening;
  /* Start from where a running animation is now, so a quick second click reverses smoothly. */
  const from = details.open && panel ? panel.getBoundingClientRect().height : 0;
  details.faqAnim?.cancel();
  if (!panel || still() || !panel.animate) {
    details.open = opening;
    return;
  }
  if (opening) details.open = true;
  const to = opening ? panel.scrollHeight : 0;
  panel.style.overflow = 'clip';
  const anim = panel.animate(
    [
      { height: `${from}px`, opacity: opening ? 0.2 : 1 },
      { height: `${to}px`, opacity: opening ? 1 : 0 },
    ],
    { duration: MS, easing: EASE }
  );
  details.faqAnim = anim;
  const done = () => {
    if (details.faqAnim !== anim) return;
    details.faqAnim = null;
    panel.style.overflow = '';
    if (!opening) details.open = false;
  };
  anim.onfinish = done;
  anim.oncancel = () => {
    if (details.faqAnim === anim) details.faqAnim = null;
    panel.style.overflow = '';
  };
}

function initList(list) {
  if (list.dataset.faqReady) return;
  list.dataset.faqReady = '1';
  const items = [...list.querySelectorAll(':scope > details')];
  /* One open at a time is handled here now, so the closing answer can animate. */
  list.removeAttribute('data-accordion');
  items.forEach((details) => {
    if (details.name) {
      details.dataset.faqGroup = details.name;
      details.removeAttribute('name');
    }
  });
  items.forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    summary?.addEventListener('click', (event) => {
      event.preventDefault();
      if (details.open && !details.faqClosing) {
        animate(details, false);
        return;
      }
      const group = details.dataset.faqGroup;
      document.querySelectorAll('.faq details[open]').forEach((other) => {
        if (other !== details && group && other.dataset.faqGroup === group && !other.faqClosing) animate(other, false);
      });
      animate(details, true);
    });
  });
}

function init(scope = document) {
  if (native) return;
  scope.querySelectorAll('.faq .qa').forEach(initList);
}

init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
